import ShoppinglistClient from './clients/ShoppinglistClient';
import ShoppinglistOverlayRows from './shoppinglists-overlay-rows';
import { displaySuccessFeedbackMessage, displayErrorFeedbackMessage } from './utilities';
import createAboPaths from './abo-paths';

class ShoppinglistOverlay
{
    constructor()
    {
        // API
        this.shoppingListClient = new ShoppinglistClient();

        // Elements
        this.body = document.querySelector('body');
        this.overlayOpenButtons = this.body.querySelectorAll('.js-overlay-shoppinglist-open-button');
        this.overlay = this.body.querySelector('.js-overlay-shoppinglist');
        this.overlayImage = this.overlay.querySelector('.js-overlay-shoppinglist-image');
        this.overlayTitle = this.overlay.querySelector('.js-overlay-shoppinglist-title');
        this.overlayVariationContainer = this.overlay.querySelector('.js-overlay-shoppinglist-variation-container');
        this.overlayVariationAttribute = this.overlay.querySelector('.js-overlay-shoppinglist-variation-attribute');
        this.overlayVariation = this.overlay.querySelector('.js-overlay-shoppinglist-variation');
        this.overlayNewListInput = this.overlay.querySelector('.js-overlay-shoppinglist-new-list-input');
        this.overlayAddListButton = this.overlay.querySelector('.js-overlay-shoppinglist-add-list-button');
        this.overlayAddProductsButton = this.overlay.querySelector('.js-overlay-shoppinglist-products-button');
        this.overlayCloseButton = this.overlay.querySelector('.js-overlay-shoppinglist-close-button');
        this.overlayListContainer = this.overlay.querySelector('.js-overlay-shoppinglist-list-container');
        this.errorInputContainer = this.body.querySelector('.js-add-list-error');
        this.errorInputFeedback = this.body.querySelector('.js-add-list-feedback-error');

        // Selectors
        this.openButtonSelector = '.js-overlay-shoppinglist-open-button';
        this.dataSelector = '#shoppinglist-overlay-data-';
        this.variationListSelector = '.js-product-variations-list';

        // Product list
        this.productList = [];

        // Helper
        this.shoppinglistOverlayRows = new ShoppinglistOverlayRows(this.overlay);
        this.defaultShoppingList = document.querySelector('meta[name="default_shopping_list_id"]');
        this.newShoppingListId = null;
    }

    init()
    {
        this.overlayOpenButtons.forEach(button =>
        {
            button.addEventListener('click', (e) =>
            {
                e.preventDefault();

                let button = e.target.closest(this.openButtonSelector);
                let productNumber = button.getAttribute('data-product-number');
                let container = button.closest(this.variationListSelector);
                let hasOverlayData = this.body.querySelector(this.dataSelector + productNumber) ? true : false;
                this.productList = [];

                if (hasOverlayData)
                {
                    let overlayData = this.body.querySelector(this.dataSelector + productNumber);
                    let hasVariations =  overlayData.getAttribute('data-productvariation') != '' ? true : false;
                    let element = container
                        .querySelector('input[name=quantity][data-product-number="' + productNumber + '"]');

                    const productData = this.prepareBodyData(element);
                    this.productList.push(productData);

                    const quantityDisplay = document.querySelector('.js-overlay-shoppinglist-quantity-value');
                    quantityDisplay.textContent = productData.quantity;

                    if (this.productList.length)
                    {
                        this.initOverlay();
                        this.initOverlayData(overlayData, hasVariations);
                        this.initOverlayImage(overlayData);
                        this.shoppinglistOverlayRows.init();
                    }
                    else
                    {
                        displayErrorFeedbackMessage('feedback.no-item-checked', '', true);
                    }
                }
                else
                {
                    displayErrorFeedbackMessage('feedback.server.error.info', '', true);
                }
            });
        });

        this.initOverlayEvents();
    }

    initOverlay()
    {
        this.showOverlay();
        this.body.addEventListener(orion.constants.EventFocusOverlayClicked, () =>
        {
            this.hideOverlay();
        });
        this.overlay.querySelector('a.close').addEventListener('click', () =>
        {
            this.hideOverlay();
        });
        this.overlayCloseButton.addEventListener('click', () =>
        {
            this.hideOverlay();
        });
    }

    initOverlayData(overlayData, hasVariations)
    {
        this.overlayTitle.innerHTML = overlayData.getAttribute('data-producttitle');
        if (hasVariations)
        {
            let contentVariationDefaultText =
                $('meta[itemprop="content.shoppinglist.variation.attribute.default.text"]').attr('content');

            let variationAttribute =
                overlayData.getAttribute('data-productVariationAttribute');

            if (variationAttribute !== 'mainColor' &&
                variationAttribute !== 'dressSize' &&
                variationAttribute !== 'shoeSize' &&
                variationAttribute !== 'packagingSize')
            {
                this.overlayVariationAttribute.innerHTML = contentVariationDefaultText;
            }
            this.overlayVariation.innerHTML = overlayData.getAttribute('data-productvariation');
            this.overlayVariationContainer.classList.remove('hidden');
        }
        else
        {
            this.overlayVariationContainer.classList.add('hidden');
        }
    }

    initOverlayImage(overlayData)
    {
        const originalSrc = overlayData.getAttribute('data-productimage');

        const aboPaths = createAboPaths(originalSrc);

        this.overlayImage.querySelector('img')
            .setAttribute('src', aboPaths.original);
        this.overlayImage.querySelector('source[type="image/avif"]')
            .setAttribute('srcset', aboPaths.avifImage + ', ' + aboPaths.avifRetinaImage + ' 2x');
        this.overlayImage.querySelector('source[type="image/webp"]')
            .setAttribute('srcset', aboPaths.webPImage + ', ' + aboPaths.webPRetinaImage + ' 2x');
        this.overlayImage.querySelector('source[type="image/jpeg"]')
            .setAttribute('srcset', aboPaths.jpgImage + ', ' + aboPaths.jpgRetinaImage + ' 2x');
    }

    initOverlayEvents()
    {
        this.overlayNewListInput.addEventListener('click', this.showAddList.bind(this));

        this.overlayListContainer.addEventListener('click', this.showAddProduct.bind(this));

        this.overlayAddListButton.addEventListener('click', this.addNewList.bind(this));

        this.overlayAddProductsButton.addEventListener('click', this.addProductsToList.bind(this));

        this.overlayNewListInput.addEventListener('input', this.inputCheck.bind(this));
    }

    showAddList()
    {
        // Buttons
        this.overlayAddListButton.classList.remove('hidden');
        this.overlayAddProductsButton.classList.add('hidden');

        // List Styling
        this.overlayListContainer.classList.add('list-disabled');
    }

    showAddProduct()
    {
        // Buttons
        this.overlayAddListButton.classList.add('hidden');
        this.overlayAddProductsButton.classList.remove('hidden');

        // List Styling
        this.overlayListContainer.classList.remove('list-disabled');

        // Input
        this.errorInputContainer.classList.remove('error', 'missing');
        this.overlayNewListInput.value = '';
        this.errorInputFeedback.classList.add('hidden');
    }


    inputCheck()
    {
        if (this.overlayNewListInput.value != '')
        {
            this.errorInputContainer.classList.remove('error', 'missing');
            this.errorInputFeedback.classList.add('hidden');
        }
    }


    addNewList()
    {
        let name = this.overlayNewListInput.value;
        let defaultShoppingListId = this.defaultShoppingList.getAttribute('content');

        let data = {
            'name': name,
            'isDefault': !defaultShoppingListId ? true : false
        };

        if (name != '')
        {
            this.shoppingListClient.createShoppinglist(data)
                .then((response) => response.json())
                .then((json) =>
                {
                    displaySuccessFeedbackMessage('content.shoppinglist.new.ok~product', '', true);
                    this.overlayNewListInput.value = '';

                    if (!defaultShoppingListId)
                    {
                        this.defaultShoppingList.setAttribute('content', json.productItemListId);
                        $('body').trigger(orion.constants.EventShoppingListDefaultUpdated);
                    }

                    this.newShoppingListId = json.productItemListId;

                    let currentShoppingListId = this.newShoppingListId
                        ? this.newShoppingListId
                        : this.overlayListContainer.querySelector('input[name=shoppinglist]:checked').value;
                    let data = {
                        'productItems': this.productList
                    };

                    this.shoppingListClient.updateItems(data, currentShoppingListId).then(() =>
                    {
                        this.newShoppingListId = null;
                        this.hideOverlay();
                        $('body').trigger(orion.constants.EventShoppingListProductUpdated);
                    });
                });
        }
        else // Input Field Error
        {
            this.errorInputContainer.classList.add('error', 'missing');
            this.errorInputFeedback.classList.remove('hidden');
        }
    }

    addProductsToList()
    {
        let currentShoppingListId = this.newShoppingListId
            ? this.newShoppingListId
            : this.overlayListContainer.querySelector('input[name=shoppinglist]:checked').value;
        let data = {
            'productItems': this.productList
        };

        this.shoppingListClient.updateItems(data, currentShoppingListId).then(() =>
        {
            displaySuccessFeedbackMessage('content.save.to.shoppinglist.ok~product', '', true);
            this.newShoppingListId = null;
            this.hideOverlay();
            $('body').trigger(orion.constants.EventShoppingListProductUpdated);
        });
    }

    prepareBodyData(element)
    {
        return {
            productNumber: element.getAttribute('data-product-number'),
            quantity: Number.parseInt(element.value)
        };
    }

    showOverlay()
    {
        this.body.classList.add('no-scroll', 'focus-active');
        this.overlay.classList.remove('hidden');
    }

    hideOverlay()
    {
        this.body.classList.remove('no-scroll', 'focus-active');
        this.overlay.classList.add('hidden');
    }
}

if (document.querySelector('body').classList.contains('authorized') && (
    document.querySelector('body').id == 'product' ||
	document.querySelector('body').id == 'campaign' ||
	document.querySelector('body').id == 'checkout-basket' ||
	document.querySelector('body').id == 'content-special' ||
	document.querySelector('body').id == 'content-epaper' ||
	document.querySelector('body').id == 'content-landing-bestseller' ||
	document.querySelector('body').id == 'category'))
{
    let shoppinglistOverlay = new ShoppinglistOverlay();

    shoppinglistOverlay.init();
}
